let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jcqZT")).then(() => parcelRequire('5sFi1'));